/* HG Lander — shared behavior. No libraries. Loaded once, deferred, by layout/theme.hg-lander.liquid */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  /* Marks an element as wired so theme-editor reloads never attach handlers twice */
  var once = function (el, k) { if (!el || el.dataset[k]) return false; el.dataset[k] = '1'; return true; };
  var money = function (cents, fmt) {
    var v = (cents / 100).toFixed(2);
    if (fmt && fmt.indexOf('{{') > -1) return fmt.replace(/\{\{\s*\w+\s*\}\}/, v);
    return '$' + v;
  };

  /* ---------- Swipe rails: arrows + dots ---------- */
  function initRails() {
    $$('[data-hgl-rail]').forEach(function (rail) {
      if (rail.dataset.hglReady) return; rail.dataset.hglReady = '1';
      var id = rail.id, items = rail.children;
      var dots = id ? $('[data-hgl-dots="' + id + '"]') : null;
      if (dots && !dots.children.length) for (var i = 0; i < items.length; i++) dots.appendChild(document.createElement('i'));
      var step = function () { var a = items[0], b = items[1]; return a ? (b ? b.offsetLeft - a.offsetLeft : a.offsetWidth) : 1; };
      var sync = function () {
        if (!dots) return;
        var idx = Math.min(items.length - 1, Math.round(rail.scrollLeft / step()));
        $$('i', dots).forEach(function (d, k) { d.classList.toggle('is-on', k === idx); });
      };
      rail.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      sync();
      if (id) $$('[data-hgl-rail-btn="' + id + '"]').forEach(function (btn) {
        btn.addEventListener('click', function () { rail.scrollBy({ left: step() * Number(btn.dataset.dir || 1), behavior: 'smooth' }); });
      });
    });
  }

  /* ---------- Accordions: one open at a time inside a group ---------- */
  function initAccordions() {
    $$('[data-hgl-accordion]').forEach(function (group) {
      if (!once(group, 'hglAcc')) return;
      $$('details', group).forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) $$('details', group).forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  /* ---------- Lander header: mobile drawer + active jump link ---------- */
  function initHeader() {
    var hdr = $('[data-hgl-header]'); if (!once(hdr, 'hglHdr')) return;
    /* Shopify wraps each section in its own div, so stick the wrapper (announcement scrolls away, bar stays) */
    var wrap = hdr.closest('.shopify-section') || hdr.closest('[data-hgl-header-wrap]'), ann = $('.hgl-announce', wrap);
    if (wrap) { wrap.classList.add('hgl-stick'); var fit = function () { wrap.style.top = ann ? -ann.offsetHeight + 'px' : '0px'; }; fit(); window.addEventListener('resize', fit); }
    var burger = $('.hgl-burger', hdr), drawer = $('.hgl-drawer', hdr);
    var set = function (open) {
      hdr.classList.toggle('is-open', open); if (drawer) drawer.hidden = !open;
      if (burger) { burger.setAttribute('aria-expanded', open); burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu'); }
    };
    if (burger) burger.addEventListener('click', function () { set(!hdr.classList.contains('is-open')); });
    if (drawer) $$('a', drawer).forEach(function (a) { a.addEventListener('click', function () { set(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
    document.addEventListener('click', function (e) { if (hdr.classList.contains('is-open') && !hdr.contains(e.target)) set(false); });
    var links = $$('.hgl-jump a', hdr);
    if (!links.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) links.forEach(function (a) { a.classList.toggle('is-on', a.getAttribute('href') === '#' + e.target.id); }); });
    }, { rootMargin: '-40% 0px -55% 0px' });
    links.forEach(function (a) { var t = document.getElementById((a.getAttribute('href') || '').slice(1)); if (t) io.observe(t); });
  }

  /* ---------- In-page links (Shop buttons, header jump links, stars): smooth scroll ---------- */
  /* One delegated listener, bound once; scrollIntoView honours each section's scroll-margin-top, so targets clear the sticky header */
  var jumpBound = false;
  function initJumpLinks() {
    if (jumpBound) return; jumpBound = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = decodeURIComponent(a.getAttribute('href').slice(1)), t = id && document.getElementById(id);
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: reduce && reduce.matches ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', '#' + id);
    });
  }

  /* ---------- Videos: nothing loads until tapped; plays inside the tile ---------- */
  function initVideos() {
    $$('[data-hgl-video]').forEach(function (btn) {
      if (!once(btn, 'hglVid')) return;
      btn.addEventListener('click', function () {
        var tile = btn.parentElement, html = '';
        var src = btn.dataset.src, ig = btn.dataset.instagram, yt = btn.dataset.youtube;
        if (src) html = '<video src="' + src + '" autoplay controls playsinline></video>';
        else if (ig) { var m = ig.match(/instagram\.com\/(?:[\w.]+\/)?(?:reels?|p|tv)\/([\w-]+)/); if (m) html = '<iframe src="https://www.instagram.com/reel/' + m[1] + '/embed" allow="autoplay; encrypted-media" title="Instagram video"></iframe>'; }
        else if (yt) { var y = yt.match(/(?:youtu\.be\/|v=|shorts\/|embed\/)([\w-]{11})/); if (y) html = '<iframe src="https://www.youtube-nocookie.com/embed/' + y[1] + '?autoplay=1&playsinline=1&rel=0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen title="YouTube video"></iframe>'; }
        if (html) tile.innerHTML = html;
      });
    });
  }

  /* ---------- Tap to enlarge (lab results etc.): opens in place, no new page ---------- */
  function initZoom() {
    $$('[data-hgl-zoom]').forEach(function (btn) {
      if (!once(btn, 'hglZoomReady')) return;
      btn.addEventListener('click', function () {
        var d = document.createElement('dialog'); d.className = 'hgl-lightbox';
        d.innerHTML = '<button type="button" class="hgl-lightbox__x" aria-label="Close">×</button><img alt="">';
        d.querySelector('img').src = btn.dataset.hglZoom;
        d.querySelector('img').alt = btn.getAttribute('aria-label') || '';
        d.addEventListener('click', function (e) { if (e.target === d || e.target.classList.contains('hgl-lightbox__x')) d.close(); });
        d.addEventListener('close', function () { d.remove(); btn.focus(); });
        document.body.appendChild(d);
        if (d.showModal) d.showModal(); else d.setAttribute('open', '');
      });
    });
  }

  /* ---------- Video tiles: muted previews take turns (Shopify videos only) ---------- */
  /* One tile plays at a time, then hands off to the next visible tile. Hover picks the tile on desktop;
     a full video with sound pauses the rotation; nothing plays while the section is off screen. */
  var MAX_TURN = 8000;
  function initVideoPreviews() {
    $$('[data-hgl-rail]').forEach(function (rail) {
      if (rail.dataset.hglTurns) return;
      var vids = $$('video[data-hgl-prev]', rail); if (!vids.length) return;
      rail.dataset.hglTurns = '1';
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; // first frames only
      var seen = [], cur = null, timer = 0, held = false, onScreen = false, hovering = false;
      var live = function () { return vids.filter(function (v) { return v.isConnected; }); };
      var stop = function () { clearTimeout(timer); if (cur && cur.isConnected) cur.pause(); };
      var play = function (v) {
        stop(); cur = v; if (!v || held || !onScreen) return;
        try { v.currentTime = 0; } catch (e) {}
        var p = v.play(); if (p && p.catch) p.catch(function () {});
        if (!hovering) timer = setTimeout(next, MAX_TURN);
      };
      var next = function () {
        var pool = live().filter(function (v) { return seen.indexOf(v) > -1; }); if (!pool.length) pool = live();
        if (!pool.length) return stop();
        var i = pool.indexOf(cur); play(pool[(i + 1) % pool.length]);
      };
      vids.forEach(function (v) {
        v.loop = false;
        v.addEventListener('ended', function () { if (v === cur && !hovering) next(); });
        var tile = v.closest('.hgl-vtile') || v.parentElement;
        tile.addEventListener('mouseenter', function () { if (!v.isConnected) return; hovering = true; play(v); });
        tile.addEventListener('mouseleave', function () { hovering = false; if (v === cur) { clearTimeout(timer); timer = setTimeout(next, 1200); } });
      });
      if ('IntersectionObserver' in window) {
        var tiles = new IntersectionObserver(function (es) {
          es.forEach(function (e) { var i = seen.indexOf(e.target); if (e.isIntersecting) { if (i < 0) seen.push(e.target); } else if (i > -1) seen.splice(i, 1); });
          seen.sort(function (a, b) { return vids.indexOf(a) - vids.indexOf(b); });
          if (onScreen && cur && seen.indexOf(cur) < 0) next();
        }, { threshold: 0.6 });
        vids.forEach(function (v) { tiles.observe(v); });
        new IntersectionObserver(function (es) {
          onScreen = es[0].isIntersecting;
          if (onScreen) play(cur && cur.isConnected ? cur : (seen[0] || live()[0])); else stop();
        }, { threshold: 0.25 }).observe(rail);
      }
      /* A tapped tile swaps in a full video with sound: hold the rotation while it plays */
      rail.addEventListener('play', function (e) { if (e.target.tagName === 'VIDEO' && !e.target.hasAttribute('data-hgl-prev')) { held = true; stop(); } }, true);
      var release = function (e) { if (e.target.tagName === 'VIDEO' && !e.target.hasAttribute('data-hgl-prev')) { held = false; if (cur && !cur.isConnected) cur = null; clearTimeout(timer); timer = setTimeout(next, 1500); } };
      rail.addEventListener('pause', release, true); rail.addEventListener('ended', release, true);
    });
  }

  /* ---------- Buy box: quantity options, pricing, cart + coupon ---------- */
  function BuyBox(root) {
    this.root = root;
    this.variantId = root.dataset.variantId;
    this.price = Number(root.dataset.price);            // cents, per unit
    this.compare = Number(root.dataset.compare || 0);   // cents, per unit (optional)
    this.fmt = root.dataset.moneyFormat;
    // cents in the shop currency; convert to the visitor's market currency so the threshold matches the prices shown
    this.freeAt = Math.round(Number(root.dataset.freeShipping || 0) * Number((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1));
    this.after = root.dataset.after || 'cart';            // cart | checkout
    this.defaultCode = root.dataset.defaultCode || '';
    this.opts = $$('[data-hgl-opt]', root);
    this.gift = $('[data-hgl-gift]', root);             // free gift row: shown and added only with options marked data-gift
    this.listeners = [];
    var self = this;
    this.opts.forEach(function (o) { self.computeOpt(o); o.addEventListener('click', function () { self.select(o); }); });
    this.atc = $('[data-hgl-atc]', root);
    if (this.atc) this.atc.addEventListener('click', function () { self.addToCart(self.atc); });
    var start = this.opts.filter(function (o) { return o.getAttribute('aria-checked') === 'true'; })[0] || this.opts[0];
    if (start) this.select(start);
    this.initGallery();
  }
  BuyBox.prototype.computeOpt = function (o) {
    var q = Number(o.dataset.qty || 1), pct = Number(o.dataset.pct || 0);
    var full = (this.compare > this.price && pct === 0 ? this.compare : this.price) * q;
    var base = this.price * q;
    var now = Math.round(base * (1 - pct / 100));
    var was = pct > 0 ? base : (this.compare > this.price ? this.compare * q : 0);
    o.dataset.total = now; o.dataset.was = was;
    o.dataset.free = this.freeAt && now >= this.freeAt ? '1' : '0';
    var days = Number(o.dataset.days || 0);
    var p = $('[data-hgl-opt-price]', o); if (p) p.innerHTML = money(now, this.fmt) + (was > now ? '<s>' + money(was, this.fmt) + '</s>' : '');
    var d = $('[data-hgl-opt-day]', o); if (d) d.textContent = days ? money(Math.round(now / days), this.fmt) + '/day' : '';
    var s = $('[data-hgl-opt-save]', o); if (s) { s.textContent = 'Save ' + pct + '%'; s.hidden = !pct; }
    var f = $('[data-hgl-opt-free]', o); if (f) f.hidden = o.dataset.free !== '1';
    void full;
  };
  BuyBox.prototype.select = function (o) {
    this.opts.forEach(function (x) { x.setAttribute('aria-checked', x === o ? 'true' : 'false'); });
    this.current = o;
    var total = Number(o.dataset.total), txt = money(total, this.fmt);
    var amt = $('[data-hgl-total]', this.root); if (amt) amt.textContent = txt;
    if (this.atc) this.atc.textContent = (this.atc.dataset.label || 'Add to Cart') + ' · ' + txt;
    if (this.gift) this.gift.hidden = o.dataset.gift !== '1';
    var ship = $('[data-hgl-ship]', this.root);
    if (ship) {
      var free = o.dataset.free === '1', t = $('span', ship), self2 = this;
      var up = this.opts.filter(function (x) { return x.dataset.free === '1'; })[0];
      ship.classList.toggle('is-free', free); ship.classList.toggle('is-upsell', !free && !!up); ship.onclick = null;
      if (t) {
        if (free) t.textContent = ship.dataset.freeText;
        else if (up) { t.textContent = ship.dataset.upsellText.replace('[option]', up.dataset.label) + ' →'; ship.onclick = function () { self2.select(up); }; }
        else t.textContent = ship.dataset.thresholdText;
      }
    }
    var self = this; this.listeners.forEach(function (fn) { fn(o, self.opts.indexOf(o)); });
  };
  BuyBox.prototype.onChange = function (fn) { this.listeners.push(fn); if (this.current) fn(this.current, this.opts.indexOf(this.current)); };
  BuyBox.prototype.addToCart = function (btn) {
    var o = this.current; if (!o || !this.variantId) return;
    var qty = Number(o.dataset.qty || 1), code = o.dataset.code || this.defaultCode, self = this;
    var label = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
    var err = $('[data-hgl-cart-error]', this.root); if (err) err.hidden = true;
    var items = [{ id: Number(this.variantId), quantity: qty }];
    if (this.gift && o.dataset.gift === '1') items.push({ id: Number(this.gift.dataset.variantId), quantity: 1 });
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
      var dest = self.after === 'checkout' ? '/checkout' : '/cart';
      // Apply the option's coupon: Shopify's /discount/CODE link stores the code and applies it at checkout.
      window.location.href = code ? '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(dest) : dest;
    }).catch(function (e) {
      btn.disabled = false; btn.textContent = label;
      if (err) { err.textContent = e.message; err.hidden = false; }
    });
  };
  BuyBox.prototype.initGallery = function () {
    var main = $('[data-hgl-gallery]', this.root); if (!main) return;
    var thumbs = $$('[data-hgl-thumb]', this.root), dots = $('[data-hgl-gallery-dots]', this.root), n = main.children.length;
    if (dots) for (var i = 0; i < n; i++) dots.appendChild(document.createElement('i'));
    var sync = function () {
      var idx = Math.round(main.scrollLeft / main.clientWidth);
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === idx); });
      if (dots) $$('i', dots).forEach(function (d, k) { d.classList.toggle('is-on', k === idx); });
    };
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { main.scrollTo({ left: main.clientWidth * k, behavior: 'smooth' }); }); });
    main.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    sync();
  };

  /* ---------- Sticky add to cart: synced with the buy box ---------- */
  function initSticky(box) {
    var bar = $('[data-hgl-sticky]'); if (!bar || !box || !once(bar, 'hglSticky')) return;
    var sel = $('select', bar), disp = $('[data-hgl-picker-disp]', bar), save = $('[data-hgl-picker-save]', bar), btn = $('[data-hgl-sticky-atc]', bar);
    box.opts.forEach(function (o, i) {
      var opt = document.createElement('option'); opt.value = i;
      opt.textContent = o.dataset.label + ' · ' + money(Number(o.dataset.total), box.fmt) + (Number(o.dataset.pct) ? ' (Save ' + o.dataset.pct + '%)' : '') + (o.dataset.gift === '1' ? ' + Free gift' : '');
      sel.appendChild(opt);
    });
    sel.addEventListener('change', function () { box.select(box.opts[Number(sel.value)]); });
    box.onChange(function (o, i) {
      sel.value = i;
      if (disp) disp.textContent = o.dataset.label + ' · ' + money(Number(o.dataset.total), box.fmt);
      if (save) { save.textContent = 'Save ' + o.dataset.pct + '%'; save.hidden = !Number(o.dataset.pct); }
    });
    if (btn && box.root.dataset.available === 'false') { btn.disabled = true; btn.textContent = 'Sold out'; }
    else if (btn) btn.addEventListener('click', function () { box.addToCart(btn); });
    // Show after the hero button (or, with no button, the whole hero) scrolls away; hide while the buy box is on screen.
    var hero = $('[data-hgl-hero-cta]') || $('[data-hgl-hero-end]'), info = $('[data-hgl-buy-info]'), heroGone = !hero, buyOn = false;
    var upd = function () { var on = heroGone && !buyOn; bar.classList.toggle('is-shown', on); document.body.classList.toggle('hgl-has-sticky', on); };
    if ('IntersectionObserver' in window) {
      if (hero) new IntersectionObserver(function (es) { var e = es[0]; heroGone = !e.isIntersecting && e.boundingClientRect.top < 0; upd(); }).observe(hero);
      if (info) new IntersectionObserver(function (es) { buyOn = es[0].isIntersecting; upd(); }, { rootMargin: '0px 0px -30% 0px' }).observe(info);
    }
    upd();
  }

  /* ---------- ® sits small and raised, wherever it appears in lander text ---------- */
  function initReg() {
    $$('.hgl').forEach(function (root) {
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, hits = [];
      while ((n = w.nextNode())) { if (n.nodeValue.indexOf('®') > -1 && !(n.parentNode.classList && n.parentNode.classList.contains('hgl-reg'))) hits.push(n); }
      hits.forEach(function (t) {
        var parts = t.nodeValue.split('®'), f = document.createElement('span');
        parts.forEach(function (txt, i) { if (txt) f.appendChild(document.createTextNode(txt)); if (i < parts.length - 1) { var s = document.createElement('sup'); s.className = 'hgl-reg'; s.textContent = '®'; f.appendChild(s); } });
        t.parentNode.replaceChild(f, t);
      });
    });
  }

  function init() {
    initReg(); initRails(); initAccordions(); initHeader(); initJumpLinks(); initVideos(); initVideoPreviews(); initZoom();
    var root = $('[data-hgl-buybox]');
    if (root && !root.hglBox) root.hglBox = new BuyBox(root);
    var box = root ? root.hglBox : null;
    initSticky(box);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init); // theme editor live preview
})();
